import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { FilterValue } from 'Vue/interfaces/LockDesigner';
import { ref, onMounted } from 'vue';
import RadioGroup from './RadioGroup.vue';

export default /*#__PURE__*/_defineComponent({
  props: {
    slug: { type: String, required: true },
    title: { type: String, required: true },
    displayExpanded: { type: Boolean, default: false },
    isSingleSelect: { type: Boolean, default: false },
    hasFilters: { type: Boolean, default: false },
    filterValues: { type: Array as () => FilterValue[], required: true },
    isSmallLabel: { type: Boolean, default: false },
    description: { type: String, default: '' }
},
  emits: ['filterChange', 'infoButtonClick'],
  setup(__props, { emit }) {

const props = __props

const componentName = 'Radio';



const selectedValue = ref<any>(null);



const onFilterChange = async(filterValues: FilterValue[]) => {
    await emit('filterChange', { slug: props.slug, filterValues });
};

const onInfoButtonClick = async() => {
    await emit('infoButtonClick');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(RadioGroup, {
      slug: props.slug,
      description: props.description,
      isSmallLabel: props.isSmallLabel,
      filterValues: props.filterValues,
      label: props.title,
      showNumResults: true,
      onRadioChange: onFilterChange
    }, null, 8 /* PROPS */, ["slug", "description", "isSmallLabel", "filterValues", "label"])
  ]))
}
}

})